export default __webpack_public_path__ + "static/media/MAGIC.953deb76.png";